module.exports = __webpack_public_path__ + "img/组 7419.5f8f8e76.png";